import React,{useState, useRef, useEffect} from 'react';
import axios from 'axios';
import {useNavigate, Link} from "react-router-dom";
import { toast } from 'react-toastify';
import MaterialReactTable from 'material-react-table';
import jwt_decode from "jwt-decode";
import HashLoader from "react-spinners/HashLoader";
import CurrencyFormat from 'react-currency-format';
import Dukcapil from './Dukcapil';

const stylespinner = {
    position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"
  }

const TambahDebitur = () => {
    const navigate = useNavigate();
    const [role, setRole] = useState("");
    const [token, setToken] = useState("");
    const [expire, setExpire] = useState(""); 
    const [pinjaman, setPinjaman] = useState([]);
    const [pinjamanPendamping, setPinjamanPendamping] = useState([]);
    const [pinjamanPenjamin1, setPinjamanPenjamin1] = useState([]);
    const [pinjamanPenjamin2, setPinjamanPenjamin2] = useState([]);
    const [pinjamanPenjamin3, setPinjamanPenjamin3] = useState([]);
    const [biodata, setBiodata] = useState([]);
    const [biodataTgl, setBiodataTgl] = useState();
    const [biodataAlamat, setBiodataAlamat] = useState();
    const [biodataPendamping, setBiodataPendamping] = useState([]);
    const [biodataPendampingTgl, setBiodataPendampingTgl] = useState();
    const [biodataPendampingAlamat, setBiodataPendampingAlamat] = useState();
    const [biodataPenjamin1, setBiodataPenjamin1] = useState([]);
    const [biodataPenjamin1Tgl, setBiodataPenjamin1Tgl] = useState();
    const [biodataPenjamin1Alamat, setBiodataPenjamin1Alamat] = useState();
    const [biodataPenjamin2, setBiodataPenjamin2] = useState([]);
    const [biodataPenjamin2Tgl, setBiodataPenjamin2Tgl] = useState();
    const [biodataPenjamin2Alamat, setBiodataPenjamin2Alamat] = useState();
    const [biodataPenjamin3, setBiodataPenjamin3] = useState([]);
    const [biodataPenjamin3Tgl, setBiodataPenjamin3Tgl] = useState();
    const [biodataPenjamin3Alamat, setBiodataPenjamin3Alamat] = useState();
    const [showBiodata, setShowBiodata] = useState(false);
    const [showbiodataPendamping, setShowBiodataPendamping] = useState(false);
    const [showbiodataPenjamin1, setShowBiodataPenjamin1] = useState(false);
    const [showbiodataPenjamin2, setShowBiodataPenjamin2] = useState(false);
    const [showbiodataPenjamin3, setShowBiodataPenjamin3] = useState(false);
    const [dukcapil, setDukcapil] = useState("SESUAI");
    const [dukcapilPendamping, setDukcapilPendamping] = useState("SESUAI");
    const [dukcapilPenjamin1, setDukcapilPenjamin1] = useState("SESUAI");
    const [dukcapilPenjamin2, setDukcapilPenjamin2] = useState("SESUAI");
    const [dukcapilPenjamin3, setDukcapilPenjamin3] = useState("SESUAI");
    const [loading, setLoading] = useState(false);
    const [cabang, setCabang] = useState("");
    const fileInputRef = useRef(null);
    const fileInputRef2 = useRef(null);
    const fileInputRef3 = useRef(null);
    const fileInputRef4 = useRef(null);
    const fileInputRef5 = useRef(null);

    useEffect(() => {
      refreshToken();
    },[]);


    const axiosJWT = axios.create();
    axiosJWT.interceptors.request.use(async(config) => {
      const curretDate = new Date();
      if(expire * 1000 < curretDate.getTime()){
          const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
          config.headers.Authorization = `Bearer ${response.data.accessToken}`;
          setToken(response.data.accessToken);
          const decoded = jwt_decode(response.data.accessToken);
          setRole(decoded.role);
          
          setCabang(decoded.cabang);
          setExpire(decoded.exp);
      }
      return config;
    }, (error) => {
      return Promise.reject(error);
    });

    const refreshToken = async() => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        // console.log("ini decode: ",decoded);
        // setUsername(decoded.username);
        // setEmail(decoded.email);
        // console.log("ini jwt: ",decoded);
        setCabang(decoded.cabang);
        setRole(decoded.role);
        setExpire(decoded.exp);

    } catch (error) {
      if(error.response){
        toast.warning("Silahkan Login!");
        navigate("/login");
      }
    }
    }   
  
    
    const toggleBiodata = () => {
      setShowBiodata(!showBiodata);
    };
    const toggleBiodataPendamping = () => {
      setShowBiodataPendamping(!showbiodataPendamping);
    };
    const toggleBiodataPenjamin1 = () => {
      setShowBiodataPenjamin1(!showbiodataPenjamin1);
    };
    const toggleBiodataPenjamin2 = () => {
      setShowBiodataPenjamin2(!showbiodataPenjamin2);
    };
    const toggleBiodataPenjamin3 = () => {
      setShowBiodataPenjamin3(!showbiodataPenjamin3);
    };

    
    function handleFileUpload1(event) {
        const file = event.target.files[0]; // Get the first file
      
        if (file) {
      
          const reader = new FileReader();
      
          reader.onload = (e) => {
            
            try {
              const fileContent = e.target.result;
              const parsedData = JSON.parse(fileContent);
              let filteredData = null;
              // console.log("DATA: ", parsedData);
              if(parsedData.individual){
                  filteredData = parsedData.individual.fasilitas.kreditPembiayan.filter(
                  (item) => item.bakiDebet !== "0"
                );
              }else{
                filteredData = parsedData.perusahaan.fasilitas.kreditPembiayan.filter(
                  (item) => item.bakiDebet !== "0"
                );
                setDukcapil("-");
                setDukcapilPendamping("-");
                setDukcapilPenjamin1("-");
                setDukcapilPenjamin2("-");
                setDukcapilPenjamin3("-");
              }
              // const updatedUploadedFiles = pinjaman ? [...pinjaman] : filteredData;
             
              // Jika ada data yang sesuai, tambahkan ke jsonDataArray
              if (filteredData.length > 0) {
                // setPinjaman(filteredData);
                setPinjaman((prevPinjaman) => [...prevPinjaman, ...filteredData]);
                toast.success("Pinjaman Debitur Ditambahkan...");
                // addDataToPinjaman(filteredData,'debitur')
                
                
                if(parsedData.individual){
                  // console.log("ini data : ",parsedData.individual.ringkasanFasilitas.kualitasBulanDataTerburuk);
                  if(parsedData.individual.dataPokokDebitur[0].tempatLahir ==="NA" && parsedData.individual.dataPokokDebitur[1]){
                    setBiodata(parsedData.individual.dataPokokDebitur[1]);
                    let dataTgl2 = parsedData.individual.dataPokokDebitur[1].tanggalLahir;
                    setBiodataTgl(dataTgl2.slice(6,8)+dataTgl2.slice(4,6)+dataTgl2.slice(0,4));
                    let alamatcstm = `${parsedData.individual.dataPokokDebitur[1].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[1].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kabKotaKet}`;
                    setBiodataAlamat(alamatcstm);
                  }else{
                    setBiodata(parsedData.individual.dataPokokDebitur[0]);
                    let dataTgl1 = parsedData.individual.dataPokokDebitur[0].tanggalLahir;
                    setBiodataTgl(dataTgl1.slice(6,8)+dataTgl1.slice(4,6)+dataTgl1.slice(0,4));
                    let alamatcstm = `${parsedData.individual.dataPokokDebitur[0].alamat}, ${parsedData.individual.dataPokokDebitur[0].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[0].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kabKotaKet}`;
                    setBiodataAlamat(alamatcstm);
                  }
                }else{
                  if(parsedData.perusahaan.dataPokokDebitur[0].tempatPendirian ==="NA"){
                    let dataTgl2 = parsedData.perusahaan.dataPokokDebitur[1].tglAktaPendirian;
                    setBiodataTgl(dataTgl2.slice(6,8)+dataTgl2.slice(4,6)+dataTgl2.slice(0,4));
                    setBiodata(parsedData.perusahaan.dataPokokDebitur[1]);
                    let alamatcstm = `${parsedData.perusahaan.dataPokokDebitur[1].alamat}, ${parsedData.perusahaan.dataPokokDebitur[1].kelurahan}, Kec.${parsedData.perusahaan.dataPokokDebitur[1].kecamatan}, ${parsedData.perusahaan.dataPokokDebitur[1].kabKotaKet}`;
                    setBiodataAlamat(alamatcstm);
                    
                  }else{
                    let dataTgl1 = parsedData.perusahaan.dataPokokDebitur[0].tglAktaPendirian;
                    setBiodata(parsedData.perusahaan.dataPokokDebitur[0]);
                    let alamatcstm = `${parsedData.perusahaan.dataPokokDebitur[0].alamat}, ${parsedData.perusahaan.dataPokokDebitur[0].kelurahan}, Kec.${parsedData.perusahaan.dataPokokDebitur[0].kecamatan}, ${parsedData.perusahaan.dataPokokDebitur[0].kabKotaKet}`;
                    setBiodataAlamat(alamatcstm);
                    setBiodataTgl(dataTgl1.slice(6,8)+dataTgl1.slice(4,6)+dataTgl1.slice(0,4));
                  }
                }
                // console.log('DATA2: ', biodata);
                
              }else{
                // setPinjaman([]);
                setPinjaman((prevPinjaman) => [...prevPinjaman, ...filteredData]);
                toast.error("Pinjaman Kosong...");
                if(parsedData.individual){
                  if(parsedData.individual.dataPokokDebitur[0].tempatLahir ==="NA" && parsedData.individual.dataPokokDebitur[1]){
                    setBiodata(parsedData.individual.dataPokokDebitur[1]);                    
                    let dataTgl2 = parsedData.individual.dataPokokDebitur[1].tanggalLahir;
                    setBiodataTgl(dataTgl2.slice(6,8)+dataTgl2.slice(4,6)+dataTgl2.slice(0,4));
                    let alamatcstm = `${parsedData.individual.dataPokokDebitur[1].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[1].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kabKotaKet}`;
                    setBiodataAlamat(alamatcstm);
                  }else{
                    setBiodata(parsedData.individual.dataPokokDebitur[0]);
                    let dataTgl1 = parsedData.individual.dataPokokDebitur[0].tanggalLahir;
                    setBiodataTgl(dataTgl1.slice(6,8)+dataTgl1.slice(4,6)+dataTgl1.slice(0,4));
                    let alamatcstm = `${parsedData.individual.dataPokokDebitur[0].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[0].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kabKotaKet}`;
                    setBiodataAlamat(alamatcstm);
                  }
                }else{
                  if(parsedData.perusahaan.dataPokokDebitur[0].tglAktaPendirian ==="NA" && parsedData.perusahaan.dataPokokDebitur[1]){
                    setBiodata(parsedData.perusahaan.dataPokokDebitur[1]);
                    let dataTgl2 = parsedData.perusahaan.dataPokokDebitur[1].tglAktaPendirian;
                    setBiodataTgl(dataTgl2.slice(6,8)+dataTgl2.slice(4,6)+dataTgl2.slice(0,4));
                    let alamatcstm = `${parsedData.perusahaan.dataPokokDebitur[1].alamat}, 
                                      ${parsedData.perusahaan.dataPokokDebitur[1].kelurahan}, 
                                      Kec.${parsedData.perusahaan.dataPokokDebitur[1].kecamatan}, 
                                      ${parsedData.perusahaan.dataPokokDebitur[1].kabKotaKet}`;
                    setBiodataAlamat(alamatcstm);
                  }else{
                    setBiodata(parsedData.perusahaan.dataPokokDebitur[0]);
                    let dataTgl1 = parsedData.perusahaan.dataPokokDebitur[0].tglAktaPendirian;
                    setBiodataTgl(dataTgl1.slice(6,8)+dataTgl1.slice(4,6)+dataTgl1.slice(0,4));
                    let alamatcstm = `${parsedData.perusahaan.dataPokokDebitur[0].alamat}, 
                                      ${parsedData.perusahaan.dataPokokDebitur[0].kelurahan}, 
                                      Kec.${parsedData.perusahaan.dataPokokDebitur[0].kecamatan}, 
                                      ${parsedData.perusahaan.dataPokokDebitur[0].kabKotaKet}`;
                    setBiodataAlamat(alamatcstm);
                  }
                }
              }
            } catch (error) {
              console.error('Gagal menguraikan file:', error);
            }
          };
          reader.readAsText(file);
        }
      }
      
      function handleFileUpload2(event) {
        const file = event.target.files[0]; // Get the first file
      
        if (file) {
      
          const reader = new FileReader();
      
          reader.onload = (e) => {
            try {
              const fileContent = e.target.result;
              const parsedData = JSON.parse(fileContent);
      
              // Filter data berdasarkan kolom bakiDebet yang tidak 0
              const filteredData = parsedData.individual.fasilitas.kreditPembiayan.filter(
                (item) => item.bakiDebet !== "0"
              );
      
              // Jika ada data yang sesuai, tambahkan ke jsonDataArray
              if (filteredData.length > 0) {
                // setPinjamanPendamping(filteredData);
                setPinjamanPendamping((prevPinjaman) => [...prevPinjaman, ...filteredData]);
                toast.success("Pinjaman Pendamping Ditambahkan...");
                // addDataToPinjaman(filteredData,'pendamping')
                if(parsedData.individual.dataPokokDebitur[0].tempatLahir ==="NA" && parsedData.individual.dataPokokDebitur[1]){
                  let dataTgl1 = parsedData.individual.dataPokokDebitur[1].tanggalLahir;
                  setBiodataPendampingTgl(dataTgl1.slice(6,8)+dataTgl1.slice(4,6)+dataTgl1.slice(0,4));
                  setBiodataPendamping(parsedData.individual.dataPokokDebitur[1]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[1].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[1].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kabKotaKet}`;
                    setBiodataPendampingAlamat(alamatcstm);
                }else{
                  let dataTgl2 = parsedData.individual.dataPokokDebitur[0].tanggalLahir;
                  setBiodataPendampingTgl(dataTgl2.slice(6,8)+dataTgl2.slice(4,6)+dataTgl2.slice(0,4));
                  setBiodataPendamping(parsedData.individual.dataPokokDebitur[0]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[0].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[0].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kabKotaKet}`;
                    setBiodataPendampingAlamat(alamatcstm);
                }
                // console.log('INI : ', filteredData);
              }else{
                // setPinjamanPendamping([]);
                setPinjamanPendamping((prevPinjaman) => [...prevPinjaman, ...filteredData]);
                toast.error("Pinjaman Pendamping Kosong...");
                if(parsedData.individual.dataPokokDebitur[0].tempatLahir ==="NA" && parsedData.individual.dataPokokDebitur[1]){
                  let dataTgl2 = parsedData.individual.dataPokokDebitur[1].tanggalLahir;
                  setBiodataPendampingTgl(dataTgl2.slice(6,8)+dataTgl2.slice(4,6)+dataTgl2.slice(0,4));
                  setBiodataPendamping(parsedData.individual.dataPokokDebitur[1]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[1].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[1].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kabKotaKet}`;
                    setBiodataPendampingAlamat(alamatcstm);
                }else{
                  let dataTgl1 = parsedData.individual.dataPokokDebitur[0].tanggalLahir;
                  setBiodataPendampingTgl(dataTgl1.slice(6,8)+dataTgl1.slice(4,6)+dataTgl1.slice(0,4));
                  setBiodataPendamping(parsedData.individual.dataPokokDebitur[0]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[0].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[0].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kabKotaKet}`;
                    setBiodataPendampingAlamat(alamatcstm);
                }
              }
      
            } catch (error) {
              console.error('Gagal menguraikan file:', error);
            }
          };
      
          reader.readAsText(file);
        }
      }
      // console.log('biodata: ', biodata);
      function handleFileUpload3(event) {
        const file = event.target.files[0]; // Get the first file
      
        if (file) {
      
          const reader = new FileReader();
      
          reader.onload = (e) => {
            try {
              const fileContent = e.target.result;
              const parsedData = JSON.parse(fileContent);
      
              // Filter data berdasarkan kolom bakiDebet yang tidak 0
              const filteredData = parsedData.individual.fasilitas.kreditPembiayan.filter(
                (item) => item.bakiDebet !== "0"
              );
      
              // Jika ada data yang sesuai, tambahkan ke jsonDataArray
              if (filteredData.length > 0) {
                // setPinjamanPenjamin1(filteredData);
                setPinjamanPenjamin1((prevPinjaman) => [...prevPinjaman, ...filteredData]);
                toast.success("Pinjaman Penjamin 1 Ditambahkan...");
                // addDataToPinjaman(filteredData,'penjamin1')
                if(parsedData.individual.dataPokokDebitur[0].tempatLahir ==="NA" && parsedData.individual.dataPokokDebitur[1]){
                  let dataTgl2 = parsedData.individual.dataPokokDebitur[1].tanggalLahir;
                  setBiodataPenjamin1Tgl(dataTgl2.slice(6,8)+dataTgl2.slice(4,6)+dataTgl2.slice(0,4));
                  setBiodataPenjamin1(parsedData.individual.dataPokokDebitur[1]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[1].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[1].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kabKotaKet}`;
                    setBiodataPenjamin1Alamat(alamatcstm);
                }else{
                  let dataTgl1 = parsedData.individual.dataPokokDebitur[0].tanggalLahir;
                  setBiodataPenjamin1Tgl(dataTgl1.slice(6,8)+dataTgl1.slice(4,6)+dataTgl1.slice(0,4));
                  setBiodataPenjamin1(parsedData.individual.dataPokokDebitur[0]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[0].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[0].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kabKotaKet}`;
                    setBiodataPenjamin1Alamat(alamatcstm);
                }
                // console.log('INI : ', filteredData);
              }else{
                // setPinjamanPenjamin1([]);
                setPinjamanPenjamin1((prevPinjaman) => [...prevPinjaman, ...filteredData]);
                toast.error("Pinjaman Penjamin 1 Kosong...");
                if(parsedData.individual.dataPokokDebitur[0].tempatLahir ==="NA" && parsedData.individual.dataPokokDebitur[1]){
                  let dataTgl2 = parsedData.individual.dataPokokDebitur[1].tanggalLahir;
                  setBiodataPenjamin1Tgl(dataTgl2.slice(6,8)+dataTgl2.slice(4,6)+dataTgl2.slice(0,4));
                  setBiodataPenjamin1(parsedData.individual.dataPokokDebitur[1]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[1].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[1].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kabKotaKet}`;
                    setBiodataPenjamin1Alamat(alamatcstm);
                }else{
                  let dataTgl1 = parsedData.individual.dataPokokDebitur[0].tanggalLahir;
                  setBiodataPenjamin1Tgl(dataTgl1.slice(6,8)+dataTgl1.slice(4,6)+dataTgl1.slice(0,4));
                  setBiodataPenjamin1(parsedData.individual.dataPokokDebitur[0]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[0].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[0].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kabKotaKet}`;
                    setBiodataPenjamin1Alamat(alamatcstm);
                }
              }
      
            } catch (error) {
              console.error('Gagal menguraikan file:', error);
            }
          };
      
          reader.readAsText(file);
        }
      }

      function handleFileUpload4(event) {
        const file = event.target.files[0]; // Get the first file
      
        if (file) {
      
          const reader = new FileReader();
      
          reader.onload = (e) => {
            try {
              const fileContent = e.target.result;
              const parsedData = JSON.parse(fileContent);
              // Filter data berdasarkan kolom bakiDebet yang tidak 0
              const filteredData = parsedData.individual.fasilitas.kreditPembiayan.filter(
                (item) => item.bakiDebet !== "0"
              );
      
              // Jika ada data yang sesuai, tambahkan ke jsonDataArray
              if (filteredData.length > 0) {
                // setPinjamanPenjamin2(filteredData);
                setPinjamanPenjamin2((prevPinjaman) => [...prevPinjaman, ...filteredData]);
                toast.success("Pinjaman Penjamin 2 Ditambahkan...");
                // addDataToPinjaman(filteredData,'penjamin2')
                if(parsedData.individual.dataPokokDebitur[0].tempatLahir ==="NA" && parsedData.individual.dataPokokDebitur[1]){
                  let dataTgl2 = parsedData.individual.dataPokokDebitur[1].tanggalLahir;
                  setBiodataPenjamin2Tgl(dataTgl2.slice(6,8)+dataTgl2.slice(4,6)+dataTgl2.slice(0,4));
                  setBiodataPenjamin2(parsedData.individual.dataPokokDebitur[1]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[1].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[1].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kabKotaKet}`;
                    setBiodataPenjamin2Alamat(alamatcstm);
                }else{
                  let dataTgl1 = parsedData.individual.dataPokokDebitur[0].tanggalLahir;
                  setBiodataPenjamin2Tgl(dataTgl1.slice(6,8)+dataTgl1.slice(4,6)+dataTgl1.slice(0,4));
                  setBiodataPenjamin2(parsedData.individual.dataPokokDebitur[0]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[0].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[0].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kabKotaKet}`;
                    setBiodataPenjamin2Alamat(alamatcstm);
                }
                // console.log('INI : ', filteredData);
              }else{
                // setPinjamanPenjamin2([]);
                setPinjamanPenjamin2((prevPinjaman) => [...prevPinjaman, ...filteredData]);
                toast.error("Pinjaman Penjamin 2 Kosong...");
                if(parsedData.individual.dataPokokDebitur[0].tempatLahir ==="NA" && parsedData.individual.dataPokokDebitur[1]){
                  let dataTgl2 = parsedData.individual.dataPokokDebitur[1].tanggalLahir;
                  setBiodataPenjamin2Tgl(dataTgl2.slice(6,8)+dataTgl2.slice(4,6)+dataTgl2.slice(0,4));
                  setBiodataPenjamin2(parsedData.individual.dataPokokDebitur[1]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[1].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[1].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kabKotaKet}`;
                    setBiodataPenjamin2Alamat(alamatcstm);
                }else{
                  let dataTgl1 = parsedData.individual.dataPokokDebitur[0].tanggalLahir;
                  setBiodataPenjamin2Tgl(dataTgl1.slice(6,8)+dataTgl1.slice(4,6)+dataTgl1.slice(0,4));
                  setBiodataPenjamin2(parsedData.individual.dataPokokDebitur[0]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[0].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[0].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kabKotaKet}`;
                    setBiodataPenjamin2Alamat(alamatcstm);
                }
              }
      
            } catch (error) {
              console.error('Gagal menguraikan file:', error);
            }
          };
      
          reader.readAsText(file);
        }
      }
      
      function handleFileUpload5(event) {
        const file = event.target.files[0]; // Get the first file
      
        if (file) {
      
          const reader = new FileReader();
      
          reader.onload = (e) => {
            try {
              const fileContent = e.target.result;
              const parsedData = JSON.parse(fileContent);
      
              // Filter data berdasarkan kolom bakiDebet yang tidak 0
              const filteredData = parsedData.individual.fasilitas.kreditPembiayan.filter(
                (item) => item.bakiDebet !== "0"
              );
      
              // Jika ada data yang sesuai, tambahkan ke jsonDataArray
              if (filteredData.length > 0) {
                // setPinjamanPenjamin3(filteredData);
                setPinjamanPenjamin3((prevPinjaman) => [...prevPinjaman, ...filteredData]);
                toast.success("Pinjaman Penjamin 3 Ditambahkan...");
                // addDataToPinjaman(filteredData,'penjamin2')
                if(parsedData.individual.dataPokokDebitur[0].tempatLahir ==="NA" && parsedData.individual.dataPokokDebitur[1]){
                  let dataTgl2 = parsedData.individual.dataPokokDebitur[1].tanggalLahir;
                  setBiodataPenjamin3Tgl(dataTgl2.slice(6,8)+dataTgl2.slice(4,6)+dataTgl2.slice(0,4));
                  setBiodataPenjamin3(parsedData.individual.dataPokokDebitur[1]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[1].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[1].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kabKotaKet}`;
                    setBiodataPenjamin3Alamat(alamatcstm);
                }else{
                  let dataTgl1 = parsedData.individual.dataPokokDebitur[0].tanggalLahir;
                  setBiodataPenjamin3Tgl(dataTgl1.slice(6,8)+dataTgl1.slice(4,6)+dataTgl1.slice(0,4));
                  setBiodataPenjamin3(parsedData.individual.dataPokokDebitur[0]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[0].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[0].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kabKotaKet}`;
                    setBiodataPenjamin3Alamat(alamatcstm);
                }
                // console.log('INI : ', filteredData);
              }else{
                // setPinjamanPenjamin3([]);
                setPinjamanPenjamin3((prevPinjaman) => [...prevPinjaman, ...filteredData]);
                toast.error("Pinjaman Penjamin 3  Kosong...");
                if(parsedData.individual.dataPokokDebitur[0].tempatLahir ==="NA" && parsedData.individual.dataPokokDebitur[1]){
                  let dataTgl2 = parsedData.individual.dataPokokDebitur[1].tanggalLahir;
                  setBiodataPenjamin3Tgl(dataTgl2.slice(6,8)+dataTgl2.slice(4,6)+dataTgl2.slice(0,4));
                  setBiodataPenjamin3(parsedData.individual.dataPokokDebitur[1]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[1].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[1].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[1].kabKotaKet}`;
                    setBiodataPenjamin3Alamat(alamatcstm);
                }else{
                  let dataTgl1 = parsedData.individual.dataPokokDebitur[0].tanggalLahir;
                  setBiodataPenjamin1Tgl(dataTgl1.slice(6,8)+dataTgl1.slice(4,6)+dataTgl1.slice(0,4));
                  setBiodataPenjamin3(parsedData.individual.dataPokokDebitur[0]);
                  let alamatcstm = `${parsedData.individual.dataPokokDebitur[0].alamat}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kelurahan}, 
                                      Kec.${parsedData.individual.dataPokokDebitur[0].kecamatan}, 
                                      ${parsedData.individual.dataPokokDebitur[0].kabKotaKet}`;
                    setBiodataPenjamin3Alamat(alamatcstm);
                }
                // 
              }
      
            } catch (error) {
              console.error('Gagal menguraikan file:', error);
            }
          };
      
          reader.readAsText(file);
        }
      }

      function hitungJangkaWaktu(tanggalMulai, tanggalJatuhTempo) {
        const dateMulai = new Date(
          parseInt(tanggalMulai.substring(0, 4)),
          parseInt(tanggalMulai.substring(4, 6)) - 1,
          parseInt(tanggalMulai.substring(6, 8))
        );
      
        const dateJatuhTempo = new Date(
          parseInt(tanggalJatuhTempo.substring(0, 4)),
          parseInt(tanggalJatuhTempo.substring(4, 6)) - 1,
          parseInt(tanggalJatuhTempo.substring(6, 8))
        );
      
        const selisihBulan = (dateJatuhTempo.getFullYear() - dateMulai.getFullYear()) * 12 +
          (dateJatuhTempo.getMonth() - dateMulai.getMonth());
      
        return selisihBulan;
      }

      function hitungAngsuranFixed(plafon, sukuBunga, jangkaWaktu, metode = "flat") {
        
          const pokok = Number(plafon);
          const bungaTahunan = Number(sukuBunga) / 100;
          const tenor = Number(jangkaWaktu);

          if (
              !Number.isFinite(pokok) || pokok <= 0 ||
              !Number.isFinite(bungaTahunan) || bungaTahunan < 0 ||
              !Number.isInteger(tenor) || tenor <= 0
          ) {
              throw new Error("Input plafon, bunga, atau tenor tidak valid.");
          }

          const bungaBulanan = bungaTahunan / 12;

          let angsuran;

          if (metode.toLowerCase() === "flat") {
              // Bunga flat: dihitung dari plafon awal
              angsuran = (pokok / tenor) + (pokok * bungaBulanan);
          } else if (metode.toLowerCase() === "anuitas") {
              // Bunga anuitas: bunga dihitung dari saldo pokok
              if (bungaBulanan === 0) {
                  angsuran = pokok / tenor;
              } else {
                  angsuran =
                      pokok *
                      bungaBulanan /
                      (1 - Math.pow(1 + bungaBulanan, -tenor));
              }
          } else {
              throw new Error('Metode harus "flat" atau "anuitas".');
          }

          return Math.round(angsuran);
      }

      const handleSave = async (event) => {
        
        setLoading(true);
        
        const pinjamanCustom = pinjaman.map((item) => ({
          namaBank: item.ljkKet,
          plafond: item.plafonAwal,
          bakiDebet: item.bakiDebet,
          bakiDebet: item.bakiDebet,
          angsuran: hitungAngsuranFixed(item.plafonAwal, item.sukuBungaImbalan, hitungJangkaWaktu(item.tanggalMulai, item.tanggalJatuhTempo)),
          coll: `${item.kualitas} - ${item.kualitasKet}`,
          kondisi: item.kondisiKet,
          jmlHariTunggakan: item.jumlahHariTunggakan,
          jaminan: item.agunan[0] ? `${item.agunan[0].jenisAgunanKet} A.N ${item.agunan[0].namaPemilikAgunan}` : "Data Tidak Tersedia",
          sukuBunga: item.sukuBungaImbalan,
          tglMulai: item.tanggalMulai, 
          tglJatuhTempo: item.tanggalJatuhTempo,
          jangkaWaktu: hitungJangkaWaktu(item.tanggalMulai, item.tanggalJatuhTempo), // Menggunakan fungsi hitungJangkaWaktu,
          tglUpdateSlik: item.tanggalUpdate.substring(0, 8) ? item.tanggalUpdate.substring(0, 8) : item.tanggalDibentuk.substring(0, 8),
          jenisSukuBungaImbalanKet: item.jenisSukuBungaImbalanKet,
          sebabMacetKet: item.sebabMacetKet,
          tanggalMacet: item.tanggalMacet,
          tunggakanBunga: item.tunggakanBunga,
          tunggakanPokok: item.tunggakanPokok,
          frekuensiTunggakan: item.frekuensiTunggakan,
          keterangan: item.keterangan,
          denda: item.denda,
          sektorEkonomi: item.sektorEkonomi,
          sektorEkonomiKet: item.sektorEkonomiKet,
          kreditProgramPemerintahKet: item.kreditProgramPemerintahKet,
          kategoriDebiturKet: item.kategoriDebiturKet,
        }));

        const biodataCustom = [{
                namaLengkap: biodata.bentukBuKet === 'Perseroan Terbatas' && !biodata.namaDebitur.startsWith('PT') ? `PT. ${biodata.namaDebitur}` : biodata.bentukBuKet === 'Commanditer Venotschap (CV)' && !biodata.namaDebitur.startsWith('CV') ? `CV. ${biodata.namaDebitur}` : biodata.namaDebitur,
                jenisKelamin: biodata.jenisKelaminKet,
                tempatLahir: biodata.tempatLahir ? biodata.tempatLahir : biodata.tempatPendirian,
                tanggalLahir: biodataTgl ? biodataTgl : '',
                alamat: biodataAlamat ? biodataAlamat.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' ') : '',
                nomorIdentitas: biodata.noIdentitas ? biodata.noIdentitas : biodata.npwp, 
                ketDukcapil: dukcapil
            } ]
       
         const pinjamanPendampingCstm = pinjamanPendamping.map((item) => ({
          namaBank: item.ljkKet,
          plafond: item.plafonAwal,
          bakiDebet: item.bakiDebet,
          angsuran: hitungAngsuranFixed(item.plafonAwal, item.sukuBungaImbalan, hitungJangkaWaktu(item.tanggalMulai, item.tanggalJatuhTempo)),
          coll: `${item.kualitas} - ${item.kualitasKet}`,
          kondisi: item.kondisiKet,
          jmlHariTunggakan: item.jumlahHariTunggakan,
          jaminan: item.agunan[0] ? `${item.agunan[0].jenisAgunanKet} A.N ${item.agunan[0].namaPemilikAgunan}` : "Data Tidak Tersedia",
          sukuBunga: item.sukuBungaImbalan,
          tglMulai: item.tanggalMulai, 
          tglJatuhTempo: item.tanggalJatuhTempo,
          jangkaWaktu: hitungJangkaWaktu(item.tanggalMulai, item.tanggalJatuhTempo),
          tglUpdateSlik: item.tanggalUpdate.substring(0, 8) ? item.tanggalUpdate.substring(0, 8) : item.tanggalDibentuk.substring(0, 8),
          
          jenisSukuBungaImbalanKet: item.jenisSukuBungaImbalanKet,
          sebabMacetKet: item.sebabMacetKet,
          tanggalMacet: item.tanggalMacet,
          tunggakanBunga: item.tunggakanBunga,
          tunggakanPokok: item.tunggakanPokok,
          frekuensiTunggakan: item.frekuensiTunggakan,
          keterangan: item.keterangan,
          denda: item.denda,
          sektorEkonomi: item.sektorEkonomi,
          sektorEkonomiKet: item.sektorEkonomiKet,
          kreditProgramPemerintahKet: item.kreditProgramPemerintahKet,
          kategoriDebiturKet: item.kategoriDebiturKet,
        }));

        const biodataPendampingCstm = [{
                namaLengkap: biodataPendamping.namaDebitur,
                jenisKelamin: biodataPendamping.jenisKelaminKet,
                tempatLahir: biodataPendamping.tempatLahir,
                tanggalLahir: biodataPendampingTgl ? biodataPendampingTgl : '',
                alamat: biodataPendampingAlamat ? biodataPendampingAlamat.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' ') : '',
                nomorIdentitas: biodataPendamping.noIdentitas, 
                ketDukcapil: dukcapilPendamping
            } ];

        const pinjamanPenjamin1Cstm = pinjamanPenjamin1.map((item) => ({
          namaBank: item.ljkKet,
          plafond: item.plafonAwal,
          bakiDebet: item.bakiDebet,
          angsuran: hitungAngsuranFixed(item.plafonAwal, item.sukuBungaImbalan, hitungJangkaWaktu(item.tanggalMulai, item.tanggalJatuhTempo)),
          coll: `${item.kualitas} - ${item.kualitasKet}`,
          kondisi: item.kondisiKet,
          jmlHariTunggakan: item.jumlahHariTunggakan,
          jaminan: item.agunan[0] ? `${item.agunan[0].jenisAgunanKet} A.N ${item.agunan[0].namaPemilikAgunan}` : "Data Tidak Tersedia",
          sukuBunga: item.sukuBungaImbalan,
          tglMulai: item.tanggalMulai, 
          tglJatuhTempo: item.tanggalJatuhTempo,
          jangkaWaktu: hitungJangkaWaktu(item.tanggalMulai, item.tanggalJatuhTempo),
          tglUpdateSlik: item.tanggalUpdate.substring(0, 8) ? item.tanggalUpdate.substring(0, 8) : item.tanggalDibentuk.substring(0, 8),
          
          jenisSukuBungaImbalanKet: item.jenisSukuBungaImbalanKet,
          sebabMacetKet: item.sebabMacetKet,
          tanggalMacet: item.tanggalMacet,
          tunggakanBunga: item.tunggakanBunga,
          tunggakanPokok: item.tunggakanPokok,
          frekuensiTunggakan: item.frekuensiTunggakan,
          keterangan: item.keterangan,
          denda: item.denda,
          sektorEkonomi: item.sektorEkonomi,
          sektorEkonomiKet: item.sektorEkonomiKet,
          kreditProgramPemerintahKet: item.kreditProgramPemerintahKet,
          kategoriDebiturKet: item.kategoriDebiturKet,
        }));

        const biodataPenjamin1Cstm = [{
                namaLengkap: biodataPenjamin1.namaDebitur,
                jenisKelamin: biodataPenjamin1.jenisKelaminKet,
                tempatLahir: biodataPenjamin1.tempatLahir,
                tanggalLahir: biodataPenjamin1Tgl ? biodataPenjamin1Tgl : '',
                alamat: biodataPenjamin1Alamat ? biodataPenjamin1Alamat.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' ') : '',
                nomorIdentitas: biodataPenjamin1.noIdentitas, 
                ketDukcapil: dukcapilPenjamin1
            } ];

        const pinjamanPenjamin2Cstm = pinjamanPenjamin2.map((item) => ({
          namaBank: item.ljkKet,
          plafond: item.plafonAwal,
          bakiDebet: item.bakiDebet,
          angsuran: hitungAngsuranFixed(item.plafonAwal, item.sukuBungaImbalan, hitungJangkaWaktu(item.tanggalMulai, item.tanggalJatuhTempo)),
          coll: `${item.kualitas} - ${item.kualitasKet}`,
          kondisi: item.kondisiKet,
          jmlHariTunggakan: item.jumlahHariTunggakan,
          jaminan: item.agunan[0] ? `${item.agunan[0].jenisAgunanKet} A.N ${item.agunan[0].namaPemilikAgunan}` : "Data Tidak Tersedia",
          sukuBunga: item.sukuBungaImbalan,
          tglMulai: item.tanggalMulai, 
          tglJatuhTempo: item.tanggalJatuhTempo,
          jangkaWaktu: hitungJangkaWaktu(item.tanggalMulai, item.tanggalJatuhTempo),
          tglUpdateSlik: item.tanggalUpdate.substring(0, 8) ? item.tanggalUpdate.substring(0, 8) : item.tanggalDibentuk.substring(0, 8),
          
          jenisSukuBungaImbalanKet: item.jenisSukuBungaImbalanKet,
          sebabMacetKet: item.sebabMacetKet,
          tanggalMacet: item.tanggalMacet,
          tunggakanBunga: item.tunggakanBunga,
          tunggakanPokok: item.tunggakanPokok,
          frekuensiTunggakan: item.frekuensiTunggakan,
          keterangan: item.keterangan,
          denda: item.denda,
          sektorEkonomi: item.sektorEkonomi,
          sektorEkonomiKet: item.sektorEkonomiKet,
          kreditProgramPemerintahKet: item.kreditProgramPemerintahKet,
          kategoriDebiturKet: item.kategoriDebiturKet,
        }));

        const biodataPenjamin2Cstm = [{
                namaLengkap: biodataPenjamin2.namaDebitur,
                jenisKelamin: biodataPenjamin2.jenisKelaminKet,
                tempatLahir: biodataPenjamin2.tempatLahir,
                tanggalLahir: biodataPenjamin2Tgl ? biodataPenjamin2Tgl : '',
                alamat: biodataPenjamin2Alamat ? biodataPenjamin2Alamat.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' ') : '',
                nomorIdentitas: biodataPenjamin2.noIdentitas, 
                ketDukcapil: dukcapilPenjamin2
            } ];

        const pinjamanPenjamin3Cstm = pinjamanPenjamin3.map((item) => ({
              namaBank: item.ljkKet,
              plafond: item.plafonAwal,
              bakiDebet: item.bakiDebet,
              angsuran: hitungAngsuranFixed(item.plafonAwal, item.sukuBungaImbalan, hitungJangkaWaktu(item.tanggalMulai, item.tanggalJatuhTempo)),
              coll: `${item.kualitas} - ${item.kualitasKet}`,
              kondisi: item.kondisiKet,
              jmlHariTunggakan: item.jumlahHariTunggakan,
              jaminan: item.agunan[0] ? `${item.agunan[0].jenisAgunanKet} A.N ${item.agunan[0].namaPemilikAgunan}` : "Data Tidak Tersedia",
              sukuBunga: item.sukuBungaImbalan,
              tglMulai: item.tanggalMulai, 
              tglJatuhTempo: item.tanggalJatuhTempo,
              jangkaWaktu: hitungJangkaWaktu(item.tanggalMulai, item.tanggalJatuhTempo),
              tglUpdateSlik: item.tanggalUpdate.substring(0, 8) ? item.tanggalUpdate.substring(0, 8) : item.tanggalDibentuk.substring(0, 8),
              
              jenisSukuBungaImbalanKet: item.jenisSukuBungaImbalanKet,
              sebabMacetKet: item.sebabMacetKet,
              tanggalMacet: item.tanggalMacet,
              tunggakanBunga: item.tunggakanBunga,
              tunggakanPokok: item.tunggakanPokok,
              frekuensiTunggakan: item.frekuensiTunggakan,
              keterangan: item.keterangan,
              denda: item.denda,
              sektorEkonomi: item.sektorEkonomi,
              sektorEkonomiKet: item.sektorEkonomiKet,
              kreditProgramPemerintahKet: item.kreditProgramPemerintahKet,
              kategoriDebiturKet: item.kategoriDebiturKet,
            }));
    
        const biodataPenjamin3Cstm = [{
                    namaLengkap: biodataPenjamin3.namaDebitur,
                    jenisKelamin: biodataPenjamin3.jenisKelaminKet,
                    tempatLahir: biodataPenjamin3.tempatLahir,
                    tanggalLahir: biodataPenjamin3Tgl ? biodataPenjamin3Tgl : '',
                    alamat: biodataPenjamin3Alamat ? biodataPenjamin3Alamat.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' ') : '',
                    nomorIdentitas: biodataPenjamin3.noIdentitas, 
                    ketDukcapil: dukcapilPenjamin3
                } ];

        event.preventDefault();
          
            let formData = new FormData();
            // console.log("Data : ", JSON.stringify(biodataCustom));
    
            formData.append('pinjaman', JSON.stringify(pinjamanCustom));
            formData.append('biodata', JSON.stringify(biodataCustom));

            formData.append('pinjamanPendamping', JSON.stringify(pinjamanPendampingCstm));
            formData.append('biodataPendamping', JSON.stringify(biodataPendampingCstm));

            formData.append('pinjamanPenjamin1', JSON.stringify(pinjamanPenjamin1Cstm));
            formData.append('biodataPenjamin1', JSON.stringify(biodataPenjamin1Cstm));

            formData.append('pinjamanPenjamin2', JSON.stringify(pinjamanPenjamin2Cstm));
            formData.append('biodataPenjamin2', JSON.stringify(biodataPenjamin2Cstm));

            formData.append('pinjamanPenjamin3', JSON.stringify(pinjamanPenjamin3Cstm));
            formData.append('biodataPenjamin3', JSON.stringify(biodataPenjamin3Cstm));

            formData.append('cabang', cabang);
    
            try {
                await axios.post(`${process.env.REACT_APP_MASTER_URL}/tambah`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                setLoading(false);
                toast.success("Data Berhasil Diupload");
                navigate("/");
            } catch (error) {
                if (error.response) {
                    setLoading(false);
                    toast.error("Data Tidak Berhasil Terkirim!");
                    const { data } = error.response;
                    console.error(`HTTP Error ${error.response.status}:`, data.error);
                } else {
                    setLoading(false);
                    toast.error("Masalah Jaringan / Server Disconnect!");
                    console.error("Network Error:", error.message);
                }
            }
                
    
      };

      const changeBiodata = (e) => {
        const { name, value } = e.target;
        // const updatedValue = name === 'alamat' ? value.replace(/"|[\r\n]+|\t/g, '') : value;
        // Periksa apakah yang sedang diubah adalah 'namaDebitur' sebelum mengubah state
        if (name === 'namaDebitur') {
          setBiodata({
            ...biodata,
            [name]: value
          });
        }if (name === 'noIdentitas') {
          setBiodata({
            ...biodata,
            [name]: value
          });
        }if (name === 'tanggalCstm') {
          setBiodataTgl(value);

        }if (name === 'tempatLahir') {
          setBiodata({
            ...biodata,
            [name]: value
          });
        }if (name === 'alamat') {
          setBiodataAlamat(value.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' '));
        }
      };

      const changeBiodataPendamping = (e) => {
        const { name, value } = e.target;
        // Periksa apakah yang sedang diubah adalah 'namaDebitur' sebelum mengubah state
        if (name === 'namaDebitur') {
          setBiodataPendamping({
            ...biodataPendamping,
            [name]: value
          });
        }if (name === 'noIdentitas') {
          setBiodataPendamping({
            ...biodataPendamping,
            [name]: value
          });
        }if (name === 'tanggalPendampingCstm') {
          setBiodataPendampingTgl(value);
        }if (name === 'tempatLahir') {
          setBiodataPendamping({
            ...biodataPendamping,
            [name]: value
          });
        }if (name === 'alamat') {
          setBiodataPendampingAlamat(value.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' '));
        }
      };

      const changeBiodataPenjamin1 = (e) => {
        const { name, value } = e.target;
        // Periksa apakah yang sedang diubah adalah 'namaDebitur' sebelum mengubah state
        if (name === 'namaDebitur') {
          setBiodataPenjamin1({
            ...biodataPenjamin1,
            [name]: value
          });
        }if (name === 'noIdentitas') {
          setBiodataPenjamin1({
            ...biodataPenjamin1,
            [name]: value
          });
        }if (name === 'tanggalPenjamin1Cstm') {
          setBiodataPenjamin1Tgl(value);
        }if (name === 'tempatLahir') {
          setBiodataPenjamin1({
            ...biodataPenjamin1,
            [name]: value
          });
        }if (name === 'alamat') {
          setBiodataPenjamin1Alamat(value.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' '));
        }
      };

      const changeBiodataPenjamin2 = (e) => {
        const { name, value } = e.target;
        // Periksa apakah yang sedang diubah adalah 'namaDebitur' sebelum mengubah state
        if (name === 'namaDebitur') {
          setBiodataPenjamin2({
            ...biodataPenjamin2,
            [name]: value
          });
        }if (name === 'noIdentitas') {
          setBiodataPenjamin2({
            ...biodataPenjamin2,
            [name]: value
          });
        }
        if (name === 'tanggalPenjamin2Cstm') {
          setBiodataPenjamin2Tgl(value);
        }
        if (name === 'tempatLahir') {
          setBiodataPenjamin2({
            ...biodataPenjamin2,
            [name]: value
          });
        }
        if (name === 'alamat') {
          setBiodataPenjamin2Alamat(value.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' '));
        }
      };

      const changeBiodataPenjamin3 = (e) => {
        const { name, value } = e.target;
        // Periksa apakah yang sedang diubah adalah 'namaDebitur' sebelum mengubah state
        if (name === 'namaDebitur') {
          setBiodataPenjamin3({
            ...biodataPenjamin3,
            [name]: value
          });
        }
        if (name === 'noIdentitas') {
          setBiodataPenjamin3({
            ...biodataPenjamin3,
            [name]: value
          });
          if (name === 'tanggalPenjamin3Cstm') {
            setBiodataPenjamin3(value);
          }}
          if (name === 'tempatLahir') {
          setBiodataPenjamin3({
            ...biodataPenjamin3,
            [name]: value
          });
        }
        if (name === 'alamat') {
          setBiodataPenjamin3Alamat(value.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' '));
        }
      };

      const handleReset = () => {
        setPinjaman([]);
        setBiodata([]);
        setBiodataTgl();
        setBiodataAlamat();
        if (fileInputRef.current) {
          fileInputRef.current.value = ''; 
        }
        setDukcapil("SESUAI");
        setDukcapilPendamping("SESUAI");
        setDukcapilPenjamin1("SESUAI");
        setDukcapilPenjamin2("SESUAI");
        setDukcapilPenjamin3("SESUAI");
        setShowBiodata(false);
        toast.error("Debitur Berhasil Dihapus...");
      };
      const handleReset2 = () => {
        setPinjamanPendamping([]);
        setBiodataPendamping([]);
        setBiodataPendampingTgl();
        setBiodataPendampingAlamat();
        if (fileInputRef2.current) {
          fileInputRef2.current.value = ''; 
        }
        setShowBiodataPendamping(false);
        toast.error("Pendamping Berhasil Dihapus...");
      };
      const handleReset3 = () => {
        setPinjamanPenjamin1([]);
        setBiodataPenjamin1([]);
        setBiodataPenjamin1Tgl();
        setBiodataPenjamin1Alamat();
        if (fileInputRef3.current) {
          fileInputRef3.current.value = ''; 
        }
        setShowBiodataPenjamin1(false);
        toast.error("Penjamin 1 Berhasil Dihapus...");
      };
      const handleReset4 = () => {
        setPinjamanPenjamin2([]);
        setBiodataPenjamin2([]);
        setBiodataPenjamin2Tgl();
        setBiodataPenjamin2Alamat();
        if (fileInputRef4.current) {
          fileInputRef4.current.value = ''; 
        }
        setShowBiodataPenjamin2(false);
        toast.error("Penjamin 2 Berhasil Dihapus...");
      };
      const handleReset5 = () => {
        setPinjamanPenjamin3([]);
        setBiodataPenjamin3([]);
        setBiodataPenjamin3Tgl();
        setBiodataPenjamin3Alamat();
        if (fileInputRef5.current) {
          fileInputRef5.current.value = ''; 
        }
        setShowBiodataPenjamin3(false);
        toast.error("Penjamin 3 Berhasil Dihapus...");
      };

      const changeDukcapil = (event) => {
        setDukcapil(event.target.value.replace(/\r?\n|\r/g, ''));
      };
      const changeDukcapilPendamping = (event) => {
        setDukcapilPendamping(event.target.value.replace(/\r?\n|\r/g, ''));
      };
      const changeDukcapilPenjamin1 = (event) => {
        setDukcapilPenjamin1(event.target.value.replace(/\r?\n|\r/g, ''));
      };
      const changeDukcapilPenjamin2 = (event) => {
        setDukcapilPenjamin2(event.target.value.replace(/\r?\n|\r/g, ''));
      };
      const changeDukcapilPenjamin3 = (event) => {
        setDukcapilPenjamin3(event.target.value.replace(/\r?\n|\r/g, ''));
      };
      
const styleTitle = {
    fontSize: 22,
    color: "#4a54f1",
    textAlign: "center",
    paddingTop: "30px",
    paddingBottom: "30px",
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)", // Menambahkan efek bayangan pada teks
    fontWeight: "bold", // Membuat teks menjadi tebal
    fontFamily: "Arial, sans-serif", // Mengubah jenis font menjadi Arial atau font lainnya
  };

  const columns = [
    {
      accessorKey: "ljkKet",
      header: "Bank",
    },
    {
      accessorKey: "bakiDebet",
      header: "Baki Debet",
      Cell: ({ row }) => (
        <CurrencyFormat
          value={row.original.bakiDebet || '0'}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'Rp.'}
        />
      ),
    },
    {
      accessorKey: "kualitas",
      header: "Coll",
      Cell: ({ row }) => (
        <>{row.original.kualitas} - {row.original.jumlahHariTunggakan}
        </>
      ),
    },
    {
      accessorKey: "kualitasKet",
      header: "Ket.",
      Cell: ({ row }) => (
        <>{row.original.kualitasKet}, {row.original.kondisiKet}
        </>
      ),
    },
    {
      accessorKey: "akadKreditPembiayaan",
      header: "JMN",
      Cell: ({ row }) => (
        <>
            {row.original.agunan[0] ? (
            <>
              {row.original.agunan[0].jenisAgunanKet} A.N {row.original.agunan[0].namaPemilikAgunan}
            </>
          ) : (
            "Data Tidak Ditemukan"
          )}
        </>
      ),
    },
    {
      accessorKey: "tanggalMulai",
      header: "Tanggal Mulai",
      Cell: ({ row }) => (
        <>{row.original.tanggalMulai.substring(6,8)}-{row.original.tanggalMulai.substring(4,6)}-{row.original.tanggalMulai.substring(0,4)}
        </>
      ),
    },
    {
      accessorKey: "tanggalJatuhTempo",
      header: "Tanggal Jatuh Tempo",
      Cell: ({ row }) => (
        <>{row.original.tanggalJatuhTempo.substring(6,8)}-{row.original.tanggalJatuhTempo.substring(4,6)}-{row.original.tanggalJatuhTempo.substring(0,4)}
        </>
      ),
    },
    {
      accessorKey: "plafonAwal",
      header: "Plafond Awal",
      Cell: ({ row }) => (
        <CurrencyFormat
          value={row.original.plafonAwal || '0'}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'Rp.'}
        />
      ),
    }, 
    {
      accessorKey: "sukuBungaImbalan",
      header: "SK BG",
      Cell: ({ row }) => (
        <>{row.original.sukuBungaImbalan}%
        </>
      ),
    },
    {
      accessorKey: "denda",
      header: "JW",
      Cell: ({ row }) => (
        <>{hitungJangkaWaktu(row.original.tanggalMulai, row.original.tanggalJatuhTempo)}
        </>
      ),
    },
    {
      accessorKey: "tanggalUpdate",
      header: "Tgl Update",
      Cell: ({ row }) => (
        <>{row.original.tanggalUpdate ? `${row.original.tanggalUpdate.substring(6,8)}-${row.original.tanggalUpdate.substring(4,6)}-${row.original.tanggalUpdate.substring(0,4)}` 
           : `${row.original.tanggalDibentuk.substring(6,8)}-${row.original.tanggalDibentuk.substring(4,6)}-${row.original.tanggalDibentuk.substring(0,4)}`}
      
        </>
      ),
    },
  ];


  return (  
    <div style={{ margin: 0, padding: 0 }}>
    
    {loading ?
      <div style={stylespinner}>
          <HashLoader
            color={'#301E67'}
            loading={loading}
            size={70}
            textAlign='centered'
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div> 
        :
   
    <div className="section is-fullheight" style={{ 
        backgroundColor: '#1b48f1', 
        filterImage:'blur(50px)'}} >
    <div className='field'></div>
      <div className="container">
        <div className="column is-12">
          <div className="box">
                <img src={`${process.env.REACT_APP_MASTER_URL2}/logonusamba.png`}  alt="Not Found" width={200} height={200}></img>
                <label className="label" style={styleTitle}>
                    <center>
                        FORM TAMBAH DEBITUR SLIK <br/> BPR BANK NUSAMBA JATIM <br/> CAB. {cabang?.toUpperCase()}
                    </center>
                </label>
             
                <div className="columnms mt 5 is-centered">
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom:'1em' }}>
                    <span>1. </span>
                    <input  className='ml-1'
                            type="file"
                            ref={fileInputRef}
                            accept=".txt"
                            onChange={(e) => handleFileUpload1(e)}
                        />
                       <button className={`${showBiodata ? 'button is-danger' : 'button is-link'}`} onClick={toggleBiodata}>
                        {showBiodata ? 'Sembunyikan' : 'Edit/Tambah Biodata'}
                      </button>
                      <button className="button is-danger ml-2" onClick={handleReset}>
                        Reset
                      </button>
                      <span style={{marginLeft:'10px', color:'red'}}>
                        <a>*Perusahaan atau Individual</a> 
                        </span>
                  </div>
                  {showBiodata && (
                    <div style={{ display: 'block', alignItems: 'center', marginBottom: '1em', marginLeft:'2em' }}>
                      <input type="text" style={{width:'200px'}} name='namaDebitur' className="input" value = {biodata.bentukBuKet === 'Perseroan Terbatas' && !biodata.namaDebitur.startsWith('PT') ? `PT. ${biodata.namaDebitur}` : biodata.bentukBuKet === 'Commanditer Venotschap (CV)' && !biodata.namaDebitur.startsWith('CV') ? `CV. ${biodata.namaDebitur}` : biodata.namaDebitur} onChange={changeBiodata} placeholder="Nama Debitur"/>
                      <input type="number" style={{width:'180px', marginLeft:'1em'}} name='noIdentitas' className="input" value={biodata.noIdentitas ? biodata.noIdentitas : biodata.npwp } onChange={changeBiodata} placeholder="NIK"/>
                      <input type="text" style={{width:'170px', marginLeft:'1em'}} name='tempatLahir' className="input" value={biodata.tempatLahir ? biodata.tempatLahir : biodata.tempatPendirian} onChange={changeBiodata} placeholder="Tempat Lahir"/>
                      <input type="number" style={{width:'120px', marginLeft:'1em'}} name='tanggalCstm' className="input" value={biodataTgl} onChange={changeBiodata} placeholder="ddmmyyyy"/>
                      {/* <textarea type="text" style={{width:'350px', height:'60px', marginLeft:'1em'}} name='alamat' className="input" value={biodata.kecamatan ? `${biodata.alamat}, ${biodata.kelurahan}, Kec.${biodata.kecamatan}, ${biodata.kabKotaKet}` : biodata.alamat} onChange={changeBiodata} placeholder="Alamat"/> */}
                      <textarea type="text" style={{width:'350px', height:'60px', marginLeft:'1em'}} name='alamat' className="input" value={biodataAlamat ? biodataAlamat.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' ') : ''} onChange={changeBiodata} placeholder="Alamat"/> 
                    </div>
                  )}
                  {biodata.namaDebitur && (
                    <div style={{ display: 'block', alignItems: 'center', marginBottom: '1em', marginLeft:'1em' }}>
                        <span><b>DUKCAPIL {biodata.bentukBuKet === 'Perseroan Terbatas' && !biodata.namaDebitur.startsWith('PT') ? `PT. ${biodata.namaDebitur}` : biodata.bentukBuKet === 'Commanditer Venotschap (CV)' && !biodata.namaDebitur.startsWith('CV') ? `CV. ${biodata.namaDebitur}` : biodata.namaDebitur} </b>:</span>
                        <textarea type="text" style={{width:'350px', height:'60px', marginLeft:'1em'}} name='dukcapil' className="input" value={biodata.namaDebitur ? dukcapil : ''} onChange={changeDukcapil} placeholder="Keterangan Dukcapil"/>
                    </div>
                  )}
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom:'1em'}}>
                    <span>2. </span>
                    <input  className='ml-1'
                            type="file"
                            ref={fileInputRef2}
                            accept=".txt"
                            onChange={(e) => handleFileUpload2(e)}
                        />
                         <button className={`${showbiodataPendamping ? 'button is-danger' : 'button is-link'}`} onClick={toggleBiodataPendamping}>
                        {showbiodataPendamping ? 'Sembunyikan' : 'Edit/Tambah Biodata'}
                      </button>
                      <button className="button is-danger ml-2" onClick={handleReset2}>
                        Reset
                      </button>
                      <span style={{marginLeft:'10px', color:'red'}}>
                        <a>*Individual</a> 
                      </span>
                  </div>
                  {showbiodataPendamping && (
                    <div style={{ display: 'block', alignItems: 'center', marginBottom: '1em', marginLeft:'2em' }}>
                      <input type="text" style={{width:'200px'}} name='namaDebitur' className="input" value={biodataPendamping.namaDebitur} onChange={changeBiodataPendamping} placeholder="Nama Debitur"/>
                      <input type="number" style={{width:'180px', marginLeft:'1em'}} name='noIdentitas' className="input" value={biodataPendamping.noIdentitas} onChange={changeBiodataPendamping} placeholder="NIK"/>
                      <input type="text" style={{width:'170px', marginLeft:'1em'}} name='tempatLahir' className="input" value={biodataPendamping.tempatLahir} onChange={changeBiodataPendamping} placeholder="Tempat Lahir"/>
                      <input type="number" maxLength={8} style={{width:'120px', marginLeft:'1em'}} name='tanggalPendampingCstm' className="input" value={biodataPendampingTgl} onChange={changeBiodataPendamping} placeholder="ddmmyyyy"/>
                      <textarea type="text" style={{width:'350px', height:'60px', marginLeft:'1em'}} name='alamat' className="input" value={biodataPendampingAlamat ? biodataPendampingAlamat.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' ') : ''} onChange={changeBiodataPendamping} placeholder="Alamat"/>
                    </div>
                  )}
                  {biodataPendamping.namaDebitur &&(
                    <div style={{ display: 'block', alignItems: 'center', marginBottom: '1em', marginLeft:'1em' }}>
                        <span><b>DUKCAPIL {biodataPendamping.namaDebitur} </b>:</span>
                        <textarea type="text" style={{width:'350px', height:'60px', marginLeft:'1em'}} name='dukcapilPendamping' className="input" value={biodataPendamping.namaDebitur ? dukcapilPendamping : ''} onChange={changeDukcapilPendamping} placeholder="Keterangan Dukcapil"/>
                    </div>
                  )}
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom:'1em' }}>
                    <span>3. </span>
                    <input className='ml-1'
                            type="file"
                            ref={fileInputRef3}
                            accept=".txt"
                            onChange={(e) => handleFileUpload3(e)}
                        />
                         <button className={`${showbiodataPenjamin1 ? 'button is-danger' : 'button is-link'}`} onClick={toggleBiodataPenjamin1}>
                        {showbiodataPenjamin1 ? 'Sembunyikan' : 'Edit/Tambah Biodata'}
                      </button>
                      <button className="button is-danger ml-2" onClick={handleReset3}>
                        Reset
                      </button>
                      <span style={{marginLeft:'10px', color:'red'}}>
                        <a>*Individual</a> 
                      </span>
                  </div>
                  {showbiodataPenjamin1 && (
                    <div style={{ display: 'block', alignItems: 'center', marginBottom: '1em', marginLeft:'2em' }}>
                      <input type="text" style={{width:'200px'}} name='namaDebitur' className="input" value={biodataPenjamin1.namaDebitur} onChange={changeBiodataPenjamin1} placeholder="Nama Debitur"/>
                      <input type="number" style={{width:'180px', marginLeft:'1em'}} name='noIdentitas' className="input" value={biodataPenjamin1.noIdentitas} onChange={changeBiodataPenjamin1} placeholder="NIK"/>
                      <input type="text" style={{width:'170px', marginLeft:'1em'}} name='tempatLahir' className="input" value={biodataPenjamin1.tempatLahir} onChange={changeBiodataPenjamin1} placeholder="Tempat Lahir"/>
                      <input type="number" maxLength={8} style={{width:'120px', marginLeft:'1em'}} name='tanggalPenjamin1Cstm' className="input" value={biodataPenjamin1Tgl} onChange={changeBiodataPenjamin1} placeholder="ddmmyyyy"/>
                      <textarea type="text" style={{width:'350px', height:'60px', marginLeft:'1em'}} name='alamat' className="input" value={biodataPenjamin1Alamat ? biodataPenjamin1Alamat.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' ') : ''} onChange={changeBiodataPenjamin1} placeholder="Alamat"/>
                    </div>
                  )}
                  {biodataPenjamin1.namaDebitur && (
                    <div style={{ display: 'block', alignItems: 'center', marginBottom: '1em', marginLeft:'1em' }}>
                        <span><b>DUKCAPIL {biodataPenjamin1.namaDebitur} </b>:</span>
                        <textarea type="text" style={{width:'350px', height:'60px', marginLeft:'1em'}} name='dukcapilPenjamin1' className="input" value={biodataPenjamin1.namaDebitur ? dukcapilPenjamin1 : ''} onChange={changeDukcapilPenjamin1} placeholder="Keterangan Dukcapil"/>
                    </div>
                  )}
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom:'1em' }}>
                    <span>4. </span>
                    <input className='ml-1'
                            type="file"
                            ref={fileInputRef4}
                            accept=".txt"
                            onChange={(e) => handleFileUpload4(e)}
                        />
                         <button className={`${showbiodataPenjamin2 ? 'button is-danger' : 'button is-link'}`} onClick={toggleBiodataPenjamin2}>
                        {showbiodataPenjamin2 ? 'Sembunyikan' : 'Edit/Tambah Biodata'}
                      </button>
                      <button className="button is-danger ml-2" onClick={handleReset4}>
                        Reset
                      </button>
                      <span style={{marginLeft:'10px', color:'red'}}>
                        <a>*Individual</a> 
                      </span>
                  </div>
                  {showbiodataPenjamin2 && (
                    <div style={{ display: 'block', alignItems: 'center', marginBottom: '1em', marginLeft:'2em' }}>
                      <input type="text" style={{width:'200px'}} name='namaDebitur' className="input" value={biodataPenjamin2.namaDebitur} onChange={changeBiodataPenjamin2} placeholder="Nama Debitur"/>
                      <input type="number" style={{width:'180px', marginLeft:'1em'}} name='noIdentitas' className="input" value={biodataPenjamin2.noIdentitas} onChange={changeBiodataPenjamin2} placeholder="NIK"/>
                      <input type="text" style={{width:'170px', marginLeft:'1em'}} name='tempatLahir' className="input" value={biodataPenjamin2.tempatLahir} onChange={changeBiodataPenjamin2} placeholder="Tempat Lahir"/>
                      <input type="number" maxLength={8} style={{width:'120px', marginLeft:'1em'}} name='tanggalPenjamin2Cstm' className="input" value={biodataPenjamin2Tgl} onChange={changeBiodataPenjamin2} placeholder="ddmmyyyy"/>
                      <textarea type="text" style={{width:'350px', height:'60px', marginLeft:'1em'}} name='alamat' className="input" value={biodataPenjamin2Alamat ? biodataPenjamin2Alamat.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' ') : ''} onChange={changeBiodataPenjamin2} placeholder="Alamat"/>
                    </div>
                  )}
                  {biodataPenjamin2.namaDebitur && (
                    <div style={{ display: 'block', alignItems: 'center', marginBottom: '1em', marginLeft:'1em' }}>
                        <span><b>DUKCAPIL {biodataPenjamin2.namaDebitur} </b>:</span>
                        <textarea type="text" style={{width:'350px', height:'60px', marginLeft:'1em'}} name='dukcapilPenjamin2' className="input" value={biodataPenjamin2.namaDebitur ? dukcapilPenjamin2 : ''} onChange={changeDukcapilPenjamin2} placeholder="Keterangan Dukcapil"/>
                    </div>
                  )}
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom:'1em'}}>
                    <span>5. </span>
                    <input className='ml-1'
                            type="file"
                            ref={fileInputRef5}
                            accept=".txt"
                            onChange={(e) => handleFileUpload5(e)}
                        />
                         <button className={`${showbiodataPenjamin3 ? 'button is-danger' : 'button is-link'}`} onClick={toggleBiodataPenjamin3}>
                        {showbiodataPenjamin3 ? 'Sembunyikan' : 'Edit/Tambah Biodata'}
                      </button>
                      <button className="button is-danger ml-2" onClick={handleReset5}>
                        Reset
                      </button>
                      <span style={{marginLeft:'10px', color:'red'}}>
                        <a>*Individual</a> 
                      </span>
                  </div>
                  {showbiodataPenjamin3 && (
                    <div style={{ display: 'block', alignItems: 'center', marginBottom: '1em', marginLeft:'2em' }}>
                      <input type="text" style={{width:'200px'}} name='namaDebitur' className="input" value={biodataPenjamin3.namaDebitur} onChange={changeBiodataPenjamin3} placeholder="Nama Debitur"/>
                      <input type="number" style={{width:'180px', marginLeft:'1em'}} name='noIdentitas' className="input" value={biodataPenjamin3.noIdentitas} onChange={changeBiodataPenjamin3} placeholder="NIK"/>
                      <input type="text" style={{width:'170px', marginLeft:'1em'}} name='tempatLahir' className="input" value={biodataPenjamin3.tempatLahir} onChange={changeBiodataPenjamin3} placeholder="Tempat Lahir"/>
                      <input type="number" maxLength={8} style={{width:'120px', marginLeft:'1em'}} name='tanggalPenjamin3Cstm' className="input" value={biodataPenjamin3Tgl} onChange={changeBiodataPenjamin3} placeholder="ddmmyyyy"/>
                      <textarea type="text" style={{width:'350px', height:'60px', marginLeft:'1em'}} name='alamat' className="input" value={biodataPenjamin3Alamat ? biodataPenjamin3Alamat.replace(/"|[\r\n]+|\t/g, '').replace(/\s{2,}/g, ' ') : ''} onChange={changeBiodataPenjamin3} placeholder="Alamat"/>
                    </div>
                  )}
                  {biodataPenjamin3.namaDebitur && (
                    <div style={{ display: 'block', alignItems: 'center', marginBottom: '1em', marginLeft:'1em' }}>
                        <span><b>DUKCAPIL {biodataPenjamin3.namaDebitur} </b>:</span>
                        <textarea type="text" style={{width:'350px', height:'60px', marginLeft:'1em'}} name='dukcapilPenjamin3' className="input" value={biodataPenjamin3.namaDebitur ? dukcapilPenjamin3 : ''} onChange={changeDukcapilPenjamin3} placeholder="Keterangan Dukcapil"/>
                    </div>
                  )}

                <div className='mt-5'>
                    {biodata && biodata != null && (
                        <div>
                            <h2><center>{biodata.namaDebitur && biodata.namaDebitur.length > 0 ? '1.' : ''} {biodata.bentukBuKet === 'Perseroan Terbatas' && !biodata.namaDebitur.startsWith('PT') ? `PT. ${biodata.namaDebitur}` : biodata.bentukBuKet === 'Commanditer Venotschap (CV)' && !biodata.namaDebitur.startsWith('CV') ? `CV. ${biodata.namaDebitur}` : biodata.namaDebitur}</center></h2>
                            {pinjaman.length === 0 && biodata.length !=0 && (
                                <table style={{ width: '100%', height: '100%', textAlign: 'center' }}>
                                <tbody>
                                    <tr>
                                    <td style={{ verticalAlign: 'middle' }}>
                                        <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'red' }}>
                                         ===== FASILITAS OUTSTANDING TIDAK DITEMUKAN =====
                                        </div>
                                    </td>
                                    </tr>
                                </tbody>
                                </table>
                            )}
                        </div>
                    )}
                    
                    {pinjaman.length > 0 && (
                        <div>
                        <MaterialReactTable enableRowNumbers columns={columns} data={pinjaman} />
                        </div>
                    )}
                    
                </div>
                <div className='mt-5'>
                    {biodataPendamping && biodataPendamping != null && (
                        <div>
                        <h2><center>{biodataPendamping.namaDebitur && biodataPendamping.namaDebitur.length > 0 ? '2.' : ''} {biodataPendamping.namaDebitur}</center></h2>
                        {pinjamanPendamping.length === 0 && biodataPendamping.length != 0 && (
                            <table style={{ width: '100%', height: '100%', textAlign: 'center' }}>
                            <tbody>
                                <tr>
                                <td style={{ verticalAlign: 'middle' }}>
                                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'red' }}>
                                    ===== FASILITAS OUTSTANDING TIDAK DITEMUKAN =====
                                    </div>
                                </td>
                                </tr>
                            </tbody>
                            </table>
                        )}
                        </div>
                    )}
                    {pinjamanPendamping.length > 0 && (
                        <div>
                        <MaterialReactTable enableRowNumbers columns={columns} data={pinjamanPendamping} />
                        </div>
                    )}
                    
                </div>
                <div className='mt-5'>
                     {biodataPenjamin1 && biodataPenjamin1 != null && (
                        <div>
                            <h2><center>{biodataPenjamin1.namaDebitur && biodataPenjamin1.namaDebitur.length > 0 ? '3.' : ''} {biodataPenjamin1.namaDebitur}</center></h2>
                            {pinjamanPenjamin1.length === 0 && biodataPenjamin1.length !=0 && (
                                <table style={{ width: '100%', height: '100%', textAlign: 'center' }}>
                                <tbody>
                                    <tr>
                                    <td style={{ verticalAlign: 'middle' }}>
                                        <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'red' }}>
                                        ===== FASILITAS OUTSTANDING TIDAK DITEMUKAN =====
                                        </div>
                                    </td>
                                    </tr>
                                </tbody>
                                </table>
                            )}
                        </div>
                     )}
                    {pinjamanPenjamin1.length > 0 && (
                        <div>
                        <MaterialReactTable enableRowNumbers columns={columns} data={pinjamanPenjamin1} />
                        </div>
                    )}
                    
                </div>
                <div className='mt-5'>
                    {biodataPenjamin2 && biodataPenjamin2 != null && (
                        <div>
                            <h2><center>{biodataPenjamin2.namaDebitur && biodataPenjamin2.namaDebitur.length > 0 ? '4.' : ''} {biodataPenjamin2.namaDebitur}</center></h2>
                            {pinjamanPenjamin2.length === 0 && biodataPenjamin2.length !=0 && (
                                <table style={{ width: '100%', height: '100%', textAlign: 'center' }}>
                                <tbody>
                                    <tr>
                                    <td style={{ verticalAlign: 'middle' }}>
                                        <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'red' }}>
                                        ===== FASILITAS OUTSTANDING TIDAK DITEMUKAN =====
                                        </div>
                                    </td>
                                    </tr>
                                </tbody>
                                </table>
                            )}
                        </div>
                    )}
                    {pinjamanPenjamin2.length > 0 && (
                        <div>
                        <MaterialReactTable enableRowNumbers columns={columns} data={pinjamanPenjamin2} />
                        </div>
                    )}

                
                </div>
                <div className='mt-5'>
                     {biodataPenjamin3 && biodataPenjamin3 != null && (
                        <div>
                            <h2><center>{biodataPenjamin3.namaDebitur && biodataPenjamin3.namaDebitur.length > 0 ? '5.' : ''} {biodataPenjamin3.namaDebitur}</center></h2>
                            {pinjamanPenjamin3.length === 0 && biodataPenjamin3.length !=0 && (
                                <table style={{ width: '100%', height: '100%', textAlign: 'center' }}>
                                <tbody>
                                    <tr>
                                    <td style={{ verticalAlign: 'middle' }}>
                                        <div style={{ fontSize: '18px', fontWeight: 'bold', color: 'red' }}>
                                        ===== FASILITAS OUTSTANDING TIDAK DITEMUKAN =====
                                        </div>
                                    </td>
                                    </tr>
                                </tbody>
                                </table>
                            )}
                        </div>
                     )}
                    {pinjamanPenjamin3.length > 0 && (
                        <div>
                        <MaterialReactTable enableRowNumbers columns={columns} data={pinjamanPenjamin3} />
                        </div>
                    )}
                    <Link to={`/`} style={{ textDecoration: "none" }} className="button is-success mr-2 mt-3">Kembali</Link>

                    <button
                        className='button is-link'
                        onClick={handleSave}
                        style={{
                        position: 'absolute',
                        bottom: 20,
                        right: '5%', // Jika Anda ingin meletakkan tombol di kanan bawah
                        margin: '10px', // Atur margin sesuai kebutuhan
                        }}
                    >
                        Save
                    </button>
                </div>

                </div>

        </div>
    </div>
    </div>
    </div>
    }
</div>
  );
}

export default TambahDebitur